import { useAppDispatch, useAppSelector } from 'hooks/redux'
import { FC, useEffect, useRef, useState } from 'react'
import { MessageType } from 'types/common'
import { hideMessage } from 'redux/slices/messages'
import styles from './styles'

const DURATION_DEFAULT = 1500 // ms

const Message: FC<MessageType> = ({ id, type, content, duration = DURATION_DEFAULT }) => {
  const [status, setStatus] = useState<'init' | 'start' | 'end'>('init')
  const dispatch = useAppDispatch()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setStatus('start')
  }, [])

  const handleAnimationEnd = () => {
    if (status === 'start') {
      setTimeout(() => {
        setStatus('end')
      }, duration)
    }
    if (status === 'end') {
      dispatch(hideMessage({ id }))
    }
  }

  return (
    <div
      className={`message ${status}`}
      onAnimationEnd={handleAnimationEnd}
      ref={ref}
    >
      <img
        src={type === 'success' ? `${process.env.PUBLIC_URL}/images/success.png` : ''}
        alt="message"
        className="message-icon"
      />
      <div className="content">{content}</div>
      <style jsx>{styles}</style>
      <style jsx>{`
        .start {
          animation: showMessage 0.3s forwards;
          z-index: 3;
        }
        .end {
          animation: hideMessage 0.3s forwards;
          z-index: 1;
        }

        @keyframes showMessage {
          from {
            opacity: 0;
            margin-top: -${ref.current ? ref.current.clientHeight : 0}px;
          }
          to {
            opacity: 1;
            margin-top: 8px;
          }
        }

        @keyframes hideMessage {
          from {
            opacity: 1;
            margin-top: 8px;
          }
          to {
            opacity: 0;
            margin-top: -${ref.current ? ref.current.clientHeight : 0}px;
          }
        }
      `}</style>
    </div>
  )
}

const Messages = () => {
  const messages = useAppSelector((state) => state.messages.messages)

  return (
    messages.length > 0 && (
      <div className="container">
        {messages.map((message) => (
          <Message
            {...message}
            key={message.id}
          />
        ))}
        <style jsx>{styles}</style>
      </div>
    )
  )
}

export default Messages
